import RegisterView from "../../views/registration/RegisterView";

export default function RegisterPage() {
  return <RegisterView />;
}
